import {PartialGameDomainModel} from "../../../partial-game/models/partial-game-domain-model";
import {GameH2hApiModel} from "./game-h2h.api-model";
import {CompetitionDomainModel} from "../../../common/competition/models/competition-domain-model";
import {SportDomainModel} from "../../../sports/models/sport-domain-model";
import {PartialGameApiModel} from "../../../partial-game/models/partial-game-api-model";
import {GameH2hCompetitorDomainModel} from "../competitor/game-h2h.competitor.domain-model";
import {H2H_LAYOUT_TYPES} from "../../../../core/consts";

export class GameH2hDomainModel extends PartialGameDomainModel {
  apiModel: GameH2hApiModel;

  constructor(
    model: GameH2hApiModel,
    competition: CompetitionDomainModel,
    homeCompetitor: GameH2hCompetitorDomainModel,
    awayCompetitor: GameH2hCompetitorDomainModel,
    startTime: Date,
    sport: SportDomainModel,
    h2hGames: Array<PartialGameApiModel>
  ) {
    super(model, competition, homeCompetitor, awayCompetitor, startTime, sport);

    this.h2hGames = h2hGames;
  }

  get h2hLayout(): String {
    return this.apiModel.h2hLayout ? this.apiModel.h2hLayout : H2H_LAYOUT_TYPES.default;
  }
}
